import React, { useEffect } from 'react'
import { useAuth } from '../context/useAuth'
import { api } from '../api/client'

const DEFAULTS = {
  '--brand-primary': '#00d4aa',
  '--brand-accent': '#1ae0b8',
  '--brand-background': '#0f0f14',
  '--brand-text': '#f8fafc',
  '--accent': '#00d4aa',
  '--accent-hover': '#1ae0b8',
  '--accent-muted': 'rgba(0, 212, 170, 0.15)',
}

function applyVars(map) {
  const root = document.documentElement
  Object.entries(map).forEach(([name, value]) => {
    if (value) root.style.setProperty(name, value)
  })
}

function isHex(value) {
  return typeof value === 'string' && /^#[0-9A-Fa-f]{3,8}$/.test(value.trim())
}

/**
 * Branding/Theme anwenden – hängt am Auth-Token, damit nach Login sofort die
 * richtigen Farben greifen (nicht erst nach Hard-Refresh).
 */
export default function BrandingTheme() {
  const { token } = useAuth()

  useEffect(() => {
    // Immer Studio-Defaults setzen (verhindert „alter Violett-Ton“ nach Login)
    applyVars(DEFAULTS)

    if (!token) return undefined

    let cancelled = false
    api
      .get('/me/branding')
      .then((r) => {
        if (cancelled || !r?.data) return
        const d = r.data
        const primary = isHex(d.palette_primary) ? d.palette_primary.trim() : null
        const accent = isHex(d.palette_accent) ? d.palette_accent.trim() : null
        const background = isHex(d.palette_background) ? d.palette_background.trim() : null
        const text = isHex(d.palette_text) ? d.palette_text.trim() : null
        const next = { ...DEFAULTS }
        if (primary) {
          next['--brand-primary'] = primary
          next['--accent'] = primary
          next['--accent-muted'] = `${primary}26`
        }
        if (accent) {
          next['--brand-accent'] = accent
          next['--accent-hover'] = accent
        }
        if (background) next['--brand-background'] = background
        if (text) next['--brand-text'] = text
        applyVars(next)
      })
      .catch(() => {
        if (!cancelled) applyVars(DEFAULTS)
      })

    return () => {
      cancelled = true
    }
  }, [token])

  return null
}
